import React, { useState } from "react";
import { Button, Form, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import S from "../lib/Security";
import N from "../lib/Network";
import { deepEqual, parseObject } from "../lib/Utils";

const OcrFilterPopover = ({
  buttonRef,
  setFilteredData,
  setActiveData,
  activeData,
  size,
  setLoading,
  setError,
  baseActiveData,
  preFilterMetadata,
  setPreFilterMetadata,
  ocrData,
  dataToDisplay,
  metadataSchema,
  baseSetLoadingMethod
}) => {
  //change this to filter parameters like const [filterParams, setFilterParams] = useState({})
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [tenantName, setTenantName] = useState("");
  const [order, setOrder] = useState("descending")
  // const [preFilterMetadata, setPreFilterMetadata] = useState(metadataSchema);

  const filterByDateTenantId = (pageNo) => {
    setLoading(true);
    let url = `getFilteredOcrReports?startDate=${startDate}&endDate=${endDate}&tenantName=${tenantName}&order=${order}&page=${pageNo}&size=${size}`;
    N.getApi(url)
      .then((res) => {
        var response = S.getDecryptedJSON(res);
        const parsedData = JSON.parse(response.responseJson);
        const metadata = parsedData.Metadata;
        delete parsedData.Metadata;
        let frontendMetadata = parseObject(metadata, metadataSchema);
        frontendMetadata.currentPage++;
        if (frontendMetadata.currentPage === metadata.totalPages)
          frontendMetadata.isLast = true;
        if (pageNo === 0)
          //if filter params have been changed then new records should be assumed. Otherwise if filter params are same then add on
          setFilteredData(parsedData.Payload.ocrReportList);
        else
          setFilteredData((prevData) => [
            ...prevData,
            ...parsedData.Payload.ocrReportList,
          ]);
        setLoading(false);
        // setPreFilterMetadata(activeData.metadata);
        setActiveData((prevData) => ({
          ...prevData,
          type: "filter",
          displayItems: parsedData.Payload.ocrReportList || [],
          filterParams: {
            startDate: startDate,
            endDate: endDate,
            tenantName: tenantName,
            order: order
          },
          metadata: frontendMetadata,
          paginationPage: 1,
        }));
        baseSetLoadingMethod(filterByDateTenantId, frontendMetadata.currentPage)
      })
      .catch((e) => {
        console.error(e);
        setError(true);
        setLoading(false);
      });
  };

  const fetchOcrReportData = () => {
    const filterParams = activeData.filterParams;
    const backendPage = activeData.metadata.currentPage;
    const providedFilters = {
      tenantName: tenantName,
      startDate: startDate,
      endDate: endDate,
      order: order
    };
    filterByDateTenantId(
      deepEqual(providedFilters, filterParams) ? backendPage : 0
    );
  };

  const resetFilter = () => {
    setStartDate("");
    setEndDate("");
    setTenantName("");
    setFilteredData([]);
    setPreFilterMetadata(preFilterMetadata);
    setActiveData((prev) => ({
      ...prev,
      ...baseActiveData,
      metadata: preFilterMetadata,
      displayItems: ocrData,
    }));
    baseSetLoadingMethod(preFilterMetadata.currentPage)
  };

  return (
    <div className="ml-2" ref={buttonRef}>
      <OverlayTrigger
        trigger="click"
        rootClose={true}
        placement="bottom-start"
        container={buttonRef.current}
        overlay={
          <Popover id="popover-basic">
            <Popover.Header as="h3">Filter Date</Popover.Header>
            <Popover.Body>
              <div className="mx-2 my-2">
                {dataToDisplay?.length != 0 ? (
                  <>
                    <div>
                      <Form.Group controlId="order" className="mb-2">
                        <Form.Label style={{ margin: "0px" }}>
                          Select Order
                        </Form.Label>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <Form.Check
                            type="radio"
                            label="Ascending"
                            name="order"
                            value="ascending"
                            checked={order === "ascending"}
                            onChange={(e) => setOrder(e.target.value)}
                          />
                          <Form.Check
                            type="radio"
                            label="Descending"
                            name="order"
                            value="descending"
                            checked={order === "descending"}
                            onChange={(e) => setOrder(e.target.value)}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group controlId="fromDate" className="mb-2">
                        <Form.Label style={{ margin: "0px" }}>
                          From Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </Form.Group>
                      <Form.Group controlId="toDate" className="mb-2">
                        <Form.Label style={{ margin: "0px" }}>
                          To Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group controlId="tenantName" className="mb-2">
                        <Form.Label style={{ margin: "0px" }}>
                          Tenant Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={tenantName}
                          onChange={(e) => setTenantName(e.target.value)}
                          placeholder="Select Tenant Name"
                        />
                      </Form.Group>
                    </div>
                    <Row className="mt-2 d-flex justify-content-around">
                      <Button
                        variant="primary"
                        className="col-5 "
                        onClick={() => fetchOcrReportData()}
                      >
                        Filter
                      </Button>
                      <Button
                        variant="secondary"
                        className="col-5 "
                        onClick={resetFilter}
                      >
                        Reset
                      </Button>
                    </Row>
                  </>
                ) : (
                  <div>No results to filter from</div>
                )}
              </div>
            </Popover.Body>
          </Popover>
        }
      >
        <Button className="btn btn-sm btn-primary shadow-sm px-4">
          <FaFilter className="fas" />
        </Button>
      </OverlayTrigger>
    </div>
  );
};

export default OcrFilterPopover;
